import { useMemo } from 'react'
import { useBMStore } from '../../stores/useBMStore'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { useTagsQuery } from './useTagsQuery'
import { useTagsStatusQuery } from './useTagsStatusQuery'
import { useSummaryQuery } from './useSummaryQuery'
import { useBlockedQuery } from './useBlockedQuery'

export const useBMData = (offset = 0) => {
  const { networkId: networkIdEnc } = useUserStore()
  const domains = useBMStore((state) => state.domains)
  const chosenDomains = useBMStore((state) => state.chosenDomains)
  const { fromDate, toDate } = useBMStore((state) => state.dateRange)
  const searchQuery = useBMStore((state) => state.searchQuery)
  const advancedFilters = useBMStore((state) => state.advancedFilters)

  const domainsParam = useMemo(() => {
    return (chosenDomains?.length ? chosenDomains : domains).map((d) => d.address)
  }, [chosenDomains, domains])

  const { data: tags, ...tagsQuery } = useTagsQuery(networkIdEnc)
  const { data: tagStatus, ...tagStatusQuery } = useTagsStatusQuery(networkIdEnc)
  const { summary, ...summaryQueryDetails } = useSummaryQuery(
    networkIdEnc,
    fromDate,
    toDate,
    domainsParam
  )
  const { data: blocked, ...blockedQuery } = useBlockedQuery(
    networkIdEnc,
    fromDate,
    toDate,
    offset,
    searchQuery,
    domains,
    advancedFilters || undefined
  )

  return {
    tags,
    tagStatus,
    summary,
    blocked,
    tagsQuery,
    tagStatusQuery,
    isLoadingSummaryQuery: summaryQueryDetails.isLoading,
    isLoadingBlockedQuery: blockedQuery.isLoading,
  }
}
